'use client'

import React from 'react'

import { MImage } from '../../../../core/MImage'
import { cn } from '../../../../utils/cn'

export interface ITextAImagesProps {
	images: Array<{
		src: string
		alt: string
	}>
	className?: string
}

export const TextAImages: React.FC<ITextAImagesProps> = ({ images, className }) => {
	if (images.length === 0) return null
	return (
		<div
			className={cn(
				'm-text-a__images',
				images.length === 3 && 'm-text-a__images--three',
				className
			)}
		>
			{images.map((image, index) => (
				<MImage key={index} src={image.src} alt={image.alt} className='m-text-a__images-img' />
			))}
		</div>
	)
}

TextAImages.displayName = 'ATextAImages'
